var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8734 8.74074C15.8734 4.90554 12.6609 1.72222 8.80621 1.72222C4.95149 1.72222 1.73905 4.90554 1.73905 8.74074C1.73905 12.5759 4.95149 15.7593 8.80621 15.7593C12.6609 15.7593 15.8734 12.5759 15.8734 8.74074ZM0.500244 8.74074C0.500244 4.13149 4.15347 0.5 8.80621 0.5C13.459 0.5 17.1122 4.13149 17.1122 8.74074C17.1122 13.35 13.459 16.9815 8.80621 16.9815C4.15347 16.9815 0.500244 13.35 0.500244 8.74074Z",
    fill: "#00C8D5",
    stroke: "#00C8D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 19.9999L13.8809 13.9258",
    stroke: "#00C8D5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.239cf8b8024b69cd3e511387cfc01b41.svg";
export { ForwardRef as ReactComponent };